import { Box } from '@mui/material';
import './lease-form.scss'
import { BreachClauses } from '../../../../../../../leaseClauses/BreachClauses';

const Step5 = () => (
  <Box className="lease-form-step5">
    <BreachClauses />
  </Box>
);

export { Step5 }
